import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { q as parseJSONString } from './index-39f51a91.js';
import { a as state } from './store-a2f488b2.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './index-54dd34b7.js';

const appPlaygroundCss = ".app-playground__range-title{font-weight:normal}@media screen and (max-width: 979px){.app-playground__range-title{font-size:18px;line-height:25px}}@media screen and (min-width: 980px){.app-playground__range-title{font-size:22px;line-height:30px}}";

const AppPlayground = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showPanel = window.location.search.indexOf('hide-panel=true') === -1;
    this.updateCount = 0;
    this.productIdToShow = undefined;
    state.on('set', () => this.updateCount++);
  }
  didCCDialogClosed() {
    this.productIdToShow = undefined;
  }
  get pesApp() {
    return h("slot", { name: "pes-app" });
  }
  get app() {
    switch (state.get('appType')) {
      case 'commerceConnector':
        return (h("div", null, parseJSONString(state.get('products'), []).map((product) => {
          return (h("div", { style: { display: 'flex' } }, h("button", { onClick: () => (this.productIdToShow = product.commercialReference) }, "Show CC for ", product.commercialReference), "-- Its price is ", h("pes-cc-price", { productId: product.commercialReference })));
        }), h("pes-cc-main", { host: state.get('host'), products: parseJSONString(state.get('products'), []), additionalDistributors: parseJSONString(state.get('additionalDistributors'), []), productIdToShow: this.productIdToShow, siteType: state.get('siteType'), localeCode: `${state.get('country')}/${state.get('language')}` })));
      case 'pesCatalog':
      default:
        return this.pesApp;
    }
  }
  render() {
    return (h(Host, { style: { display: 'block', 'padding-bottom': '40px' } }, this.app, this.showPanel && h("pes-settings-control-panel", null)));
  }
};
AppPlayground.style = appPlaygroundCss;

export { AppPlayground as pes_app_test };
